/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {Box, Card, CardContent} from '@mui/material';
import CardHeader from '@mui/material/CardHeader';

const NotFoundPage = () => {
  return (
    <Box
      sx={{
        p: 4,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Card>
        <CardHeader title={'404 Not Found'} />
        <CardContent>Sorry, the page you are looking for does not exist.</CardContent>
      </Card>
    </Box>
  );
};

export default NotFoundPage;
